module.exports = __webpack_public_path__ + "img/blue-circle-table-6.d13d3be8.png";